"use strict";

import {ContactPluginComponent} from "../../../../../../plugins/wwp-contact/public/js/contact-es6";

export class ContactThemePluginComponent extends ContactPluginComponent {

    init(){
        super.init();
    }

    static initFormPicker($pageWrap) {
        let pickerLabel = 'Votre demande concerne';
        let pickerDefaultLabel = 'Sélectionnez votre service...';

        if (window.wonderwp.i18n) {

            if (window.wonderwp.i18n.contactPickerLabel) {
                pickerLabel = window.wonderwp.i18n.contactPickerLabel;
            }
            if (window.wonderwp.i18n.themeContactPickerDefaultLabel) {
                pickerDefaultLabel = window.wonderwp.i18n.themeContactPickerDefaultLabel;
            }
        }

        let picker = '<select><option value="">' + pickerDefaultLabel + '</option>';


        var tabForm = [];
        var indexTab = 0;

        $pageWrap.find('.module-contact').each(function (index) {
            let $contactDomFrag = $(this).parent();
            $contactDomFrag.hide();
            let $title = $(this).prev();
            picker += '<option value="' + index + '">' + $title.text() + '</option>';
            var form_id = $(this).find("form").data("form");

            tabForm[form_id] = indexTab;
            indexTab++;
        });


        picker += '</select>';
        let $picker = $(picker);


        let $pickerWrap = $('<div class="picker-wrap select-wrap"><label>' + pickerLabel + '</label><div class="select-style"></div></div>');
        $pickerWrap.find('.select-style').append($picker);
        $pageWrap.find('.wrapper-contact-form').prepend($pickerWrap);

        let select = $pageWrap.find('.picker-wrap.select-wrap .select-style select');
        //select.selectric();


        select.on('change', function () {
            let formIndex = $(this).val();
            $pageWrap.find('.module-contact').parent().hide();
            let $toShow = $pageWrap.find('.module-contact:eq(' + formIndex + ')');

            $toShow.parent().show();
            $toShow.find('.questions .current input').focus();
            let $toShowSelect = $toShow.find('select');
            $($toShowSelect[0]).selectric();
            //$picker.hide();
        });


        var $pageUrl = $(location).attr("href");
        if($pageUrl.match("#")){
            var pagePieces = $pageUrl.split("#");
            let selectedForm = pagePieces[1];

            select.children().eq((tabForm[selectedForm]+1)).prop('selected', true).change();

        }


    };

}

window.initContactPicker = function(){
    var $pageWrap = $('#content > .hentry');

    if ($pageWrap.find('.module-contact').length > 1) {

        ContactThemePluginComponent.initFormPicker($pageWrap);
    }
};
window.initContactPicker();

window.pew.addRegistryEntry({key: 'wdf-plugin-contact', classDef: ContactThemePluginComponent, domSelector: '.module-contact'});



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/plugins/wwp-contact/public/js/contact.js